<template>
    <div v-if="products.length > 0" v-for="product in products"
        class="sm:p-2 miron rounded-2xl border transition-all duration-300 sm:hover:shadow-hover group">
        <div class="relative overflow-hidden rounded-xl isolate">
            <label
                class="capitalize text-xs font-semibold rounded-xl py-1 px-2 shadow-badge absolute top-3 left-3 z-10 bg-danger text-white"
                v-if="product.is_offer && product.flash_sale">{{ $t('label.flash_sale') }}</label>

            <button type="button" @click.prevent="wishlist(product)"
                :class="product.wishlist ? 'fa-solid fa-heart text-danger bg-red-100' : 'fa-regular fa-heart text-gray-500 bg-white'"
                class="w-7 h-7 leading-7 rounded-full text-center text-base shadow-badge absolute top-3 right-3 z-10">
            </button>

            <router-link class="overflow-hidden rounded-xl w-full"
                :to="{ name: 'frontend.product.details', params: { slug: product.slug } }">
                <img :src="product.cover" alt="product"
                    class="w-full rounded-xl transition-all duration-300 group-hover:scale-105 group-hover:rotate-3">
            </router-link>
        </div>

        <div class="px-2 sm:px-2 pt-4 pb-2">
            <h3
                class="capitalize text-base font-semibold whitespace-nowrap transition-all duration-300 hover:text-primary">
                <router-link class="block overflow-hidden text-ellipsis"
                    :to="{ name: 'frontend.product.details', params: { slug: product.slug } }">
                    {{ product.name }}
                </router-link>
            </h3>

            <div v-if="setting && setting.site_reviews_show_publicly === enums.activityEnum.ENABLE" class="flex flex-wrap items-center gap-2 mb-5">
                <div class="flex items-center gap-1">
                    <starRating border-color="#FFBC1F" :rounded-corners="true" :padding="2.5" :border-width="2.5"
                        :star-size="9" class="mt-[2px]" inactive-color="#FFFFFF" active-color="#FFBC1F"
                        :round-start-rating="false" :show-rating="false" :read-only="true" :max-rating="5"
                        :rating="(product.rating_star / product.rating_star_count)" />
                </div>
                <div v-if="product.rating_star_count > 0" class="flex items-center gap-1 mt-[5px]">
                    <span class="text-xs font-medium whitespace-nowrap text-text">{{ (product.rating_star /
                        product.rating_star_count).toFixed(1) }}</span>
                    <span class="text-xs font-medium whitespace-nowrap text-text hover:text-primary">({{
                        product.rating_star_count }} {{ product.rating_star_count > 1 ? $t('label.reviews') :
                        $t('label.review') }})</span>
                </div>
            </div>

            <div class="flex flex-wrap-reverse items-center border-t pt-3 gap-x-3 gap-y-1" v-if="product.is_offer">
                <h3 class="text-xl sm:text-[22px] font-bold">
                    <span class="text-danger">{{ currencyFormat(product.discounted_price_raw !== undefined ? product.discounted_price_raw : product.discounted_price) }}</span>
                </h3>
                <h4 class="text-sm sm:text-base font-semibold text-text font-title">
                    <del>{{ currencyFormat(product.price !== undefined ? product.price : product.currency_price) }}</del>
                </h4>
            </div>
            <div v-else class="w-full border-t pt-3">
                <h4 class="text-xl sm:text-[22px] font-bold">
                    <span>{{ currencyFormat(product.price !== undefined ? product.price : product.currency_price) }}</span>
                </h4>
            </div>
        </div>
    </div>
</template>

<script>

import starRating from "vue-star-rating";
import router from "../../../router";
import activityEnum from "../../../enums/modules/activityEnum";
import appService from "../../../services/appService";
export default {
    name: "ProductListComponent",
    emits: ["wishlist-changed"],
    components: {
        starRating
    },
    props: {
        "products": "object",
    },
    data() {
        return {
            rating: [],
            enums: {
                activityEnum: activityEnum
            }
        }
    },
    computed: {
        setting: function () {
            return this.$store.getters['frontendSetting/lists'];
        }
    },
    methods: {
        currencyFormat: function (amount) {
            return appService.currencyFormat(amount);
        },
        wishlist: function (product) {
            const toggle = !product.wishlist;
            product.wishlist = toggle;

            this.$store.dispatch("frontendWishlist/toggle", {
                product_id: product.id,
                toggle: toggle
            }).then((res) => {
                this.$emit("wishlist-changed", { productId: product.id, toggle: toggle });
            }).catch((err) => {
                product.wishlist = !toggle;
                if (err.response.status === 401) {
                    product.wishlist = false;
                    router.push({ name: "auth.login" });
                }
            });
        },
    }
}
</script>